module.exports = __webpack_public_path__ + "static/media/threesis_useful.3501613a.jpg";